var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"append-icon":"search","value":_vm.value},on:{"change":function($event){_vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }